import { ChevronDown } from "lucide-react";

/**
 * Flecha al pie de cada pantalla, hacia la siguiente.
 *
 * Es un ancla de verdad, no un botón con scrollTo: así hereda el
 * `scroll-behavior: smooth` y el `scroll-margin-top` del CSS, engancha con el
 * scroll-snap y sigue funcionando aunque el JavaScript falle.
 */
const NextArrow = ({ to, oscuro = false, etiqueta = "Ir a la siguiente sección" }) => (
  <a
    href={`#${to}`}
    aria-label={etiqueta}
    data-testid={`next-arrow-${to}`}
    className={`absolute left-1/2 bottom-5 -translate-x-1/2 grid h-11 w-11 place-items-center rounded-full border transition-[transform,border-color,color] duration-300 hover:translate-y-1 motion-reduce:transition-none motion-reduce:hover:translate-y-0 ${
      oscuro
        ? "border-white/25 text-[var(--gm-faint)] hover:border-[var(--gm-accent)] hover:text-[var(--gm-accent)]"
        : "border-[var(--gm-line-strong)] text-[var(--gm-muted)] hover:border-[var(--gm-accent)] hover:text-[var(--gm-accent)]"
    }`}
  >
    <ChevronDown className="h-5 w-5" strokeWidth={1.6} />
  </a>
);

export default NextArrow;
